import { gsap } from 'gsap'
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'
import { removeTrapFocus, trapFocus } from '@shopify/theme-a11y'

const modalWrapper = document.querySelector('[data-modal-wrapper]')
const modalScreen = document.querySelector('[data-modal-screen]')
const modalInner = document.querySelector('[data-modal-inner]')
const modalClose = document.querySelector('[data-modal-close]')

let focusFrom
let storedScrollY

const modalTl = gsap.timeline({
    paused: true,
    onReverseComplete: () => {
        modalInner.innerHTML = ''
        if (focusFrom) focusFrom.focus()
        removeTrapFocus()
    },
    onComplete: () => {
        trapFocus(modalWrapper)
        modalClose.focus()
    }
})

modalTl.set(modalWrapper, {
    visibility: 'visible',
    pointerEvents: 'auto'
})

modalTl.to(modalScreen, {
    autoAlpha: 1
})

modalTl.to(
    modalInner,
    {
        autoAlpha: 1
    },
    '>-=0.2'
)

modalTl.to(
    modalClose,
    {
        autoAlpha: 1
    },
    '<'
)

const openModal = () => {
    storedScrollY = window.scrollY

    modalTl.play()
    disableBodyScroll(modalInner)
    document.body.style.setProperty('top', `${window.scrollY * -1}px`)
    document.documentElement.classList.add('safari-height-fix')
    focusFrom = document.activeElement
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeModal()
        }
    })
}

const closeModal = () => {
    modalTl.reverse()
    enableBodyScroll(modalInner)
    document.documentElement.classList.remove('safari-height-fix')
    document.body.style.setProperty('top', '')
    document.body.scrollTo(0, storedScrollY)
}

modalClose.addEventListener('click', closeModal)

modalScreen.addEventListener('click', closeModal)

export { openModal }
